import type { ErrorCode, FileRejection } from 'react-dropzone';

export function getFileNamesFromRejections(
  rejections: FileRejection[],
  errorCode: ErrorCode,
) {
  return rejections.reduce((acc: string[], curr) => {
    if (curr.errors.some(({ code }) => code === errorCode)) {
      return acc.concat(curr.file.name);
    }
    return acc;
  }, []);
}
